import { createAction, props } from '@ngrx/store';

export const OpenMenu = createAction('[Nav] Open menu');
export const CloseMenu = createAction('[Nav] Close menu');
export const ToggleMenu = createAction('[Nav] Toggle menu');

export const SetNavTheme = createAction('[Nav] Set Nav Theme', props<{ theme: string }>());

export const HideFooterPayoff = createAction('[Nav] Hide footer payoff', props<{ hide: boolean }>());
